module.exports = __webpack_public_path__ + "img/down-left-white.163d6035.svg";